import styled from "styled-components"

export default function OrderItemBlock({ children }) {
  return <Block>{children}</Block>
}

const Block = styled.div`
  padding-top: calc(100vw * (21 / 375));
  padding-bottom: calc(100vw * (37 / 375));
  padding-right: calc(100vw * (17 / 375));
  padding-left: calc(100vw * (17 / 375));
  border-bottom: calc(100vw * (12 / 375)) solid #f7f7f7;
`
